import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    isLoaderVisible: false,
    loaderMessage: 'loading ... '
}

const loaderSlice = createSlice({
    name: 'loader',
    initialState,
    reducers:  {
        showLoader: (state, action) => {
            state.isLoaderVisible = true
            state.loaderMessage = action.payload
        },
        hideLoader: (state) => {
            state.isLoaderVisible = false
            state.loaderMessage = ''
        }
    }
});

export const { showLoader, hideLoader } = loaderSlice.actions
export default loaderSlice.reducer